<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const form = computed({
  get: () => props.modelValue,
  set: val => emit('update:modelValue', val),
});
</script>

<template>
  <div class="space-y-6 max-w-3xl">
    <div class="bg-n-surface-1 border border-n-weak rounded-xl p-6 space-y-4">
      <h3 class="text-base font-semibold text-n-slate-12">
        Identidade da Empresa & Atendimento
      </h3>
      <p class="text-xs text-n-slate-11">
        Defina os dados da empresa atendida pela Isa Leal e o departamento
        humano de transbordo.
      </p>

      <div class="space-y-4 pt-2">
        <div>
          <label class="block text-xs font-semibold text-n-slate-12 mb-1.5">
            Nome da Empresa / Cliente <span class="text-red-500">*</span>
          </label>
          <input
            v-model="form.nome_empresa"
            type="text"
            placeholder="Ex: Empresa Acme"
            class="reset-base !mb-0 w-full text-sm bg-n-surface-2 border border-n-weak rounded-lg px-3 py-2 text-n-slate-12 focus:border-n-brand outline-none"
            required
          />
        </div>

        <div>
          <label class="block text-xs font-semibold text-n-slate-12 mb-1.5">
            Nome do Departamento Humano
          </label>
          <input
            v-model="form.nome_departamento"
            type="text"
            placeholder="Ex: Secretaria / Atendimento Humano"
            class="reset-base !mb-0 w-full text-sm bg-n-surface-2 border border-n-weak rounded-lg px-3 py-2 text-n-slate-12 focus:border-n-brand outline-none"
          />
        </div>

        <div>
          <label class="block text-xs font-semibold text-n-slate-12 mb-1.5">
            Saudação de Abertura (Template de mensagem inicial)
          </label>
          <textarea
            v-model="form.saudacao"
            rows="3"
            placeholder="Ex: Olá! Seja bem-vindo(a) à Empresa Acme! Eu sou a Isa Leal, assistente virtual..."
            class="reset-base !mb-0 w-full text-sm bg-n-surface-2 border border-n-weak rounded-lg p-3 text-n-slate-12 focus:border-n-brand outline-none resize-y"
          />
        </div>
      </div>
    </div>
  </div>
</template>
